import { render, staticRenderFns } from "./PayPalButtons.vue?vue&type=template&id=1dea1573"
import script from "./PayPalButtons.vue?vue&type=script&lang=ts"
export * from "./PayPalButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports